import React, { FC, useCallback } from 'react';
import { Box, Divider, Stack, SxProps } from '@mui/material';
import Form from 'src/components/Form';
import { formFields } from './formData';
import { Dispatch } from 'redux';
import { FieldValues } from 'react-hook-form';
import { connect } from 'react-redux';
import { FORM_MIN_WIDTH } from './utils';
import Label from 'src/components/FormControl/Label';
import Controller from '../DetailsController';

type Props = ReturnType<typeof mapDispatchToProps>;

const ReceiptsCreateContent: FC<Props> = ({ onSubmitReceipt }) => {
  const formStyles: SxProps = {
    minWidth: FORM_MIN_WIDTH,
  };

  const formRef = React.useRef<HTMLFormElement>(null);
  const onFormSubmit = useCallback(() => {
    if (formRef.current) {
      formRef.current.requestSubmit();
    }
  }, [formRef.current]);

  return (
    <Stack width="100%">
      <Box
        display="flex"
        overflow="hidden"
        flex={1}
        sx={{ padding: ({ spacing }) => spacing(1.5, 2.5, 1.5, 5) }}
        flexDirection="column"
        paddingInlineEnd={2}
      >
        <Stack justifyContent="space-between" direction="row" zIndex={10000}>
          <Form
            ref={formRef}
            fields={formFields}
            onSubmit={onSubmitReceipt}
            styles={formStyles}
          />
          <Stack>
            <Label>קובץ מצורף</Label>
            <img
              src="https://picsum.photos/200/300"
              width={200}
              height={200}
              alt="random"
            />
          </Stack>
        </Stack>
      </Box>
      <Divider />
      <Controller onActionClick={onFormSubmit} />
    </Stack>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSubmitReceipt: (data: FieldValues) => {
    // dispatch(receiptsSetControlFilters(payload))
  },
});

export default connect(null, mapDispatchToProps)(ReceiptsCreateContent);
